import React from "react";

type Props = Readonly<{
  className?: string,
  type: string
}>

class Icon extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    className: ''
  }

  render() {
    let {
      type,
      className,
      ...rest
    } = this.props;
    return (
      <i className={"iconfont icon-"+type +' '+className} {...rest}></i>
    );
  }
}
// class Icon extends React.PureComponent<Props> {
//   constructor(props) {
//     super(props);
//   }
//
//   static defaultProps = {
//     className: ''
//   }
//
//   render() {
//     let {
//       type,
//       className
//     } = this.props;
//     return (
//       <svg className={ "icon " + className } aria-hidden="true">
//         <use xlinkHref={ "#icon-" + type }/>
//       </svg>
//     );
//   }
// }



export default Icon;
